import { GridFields } from 'components';
import { useStableKeys } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  useFormContext,
  Field,
} from 'modules/client/legal/forms/companyActivitiesForm';

import { Fields, Header } from './components';

export interface FormContentProps {
  enabledOKPOCode?: boolean;
  onRemoveActivity: (index: number) => void;
  onAddActivity: () => void;
}

export const FormContent = ({
  enabledOKPOCode,
  onRemoveActivity,
  onAddActivity,
}: FormContentProps) => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  const activityTypesKeys = useStableKeys(values.activityTypes);

  return (
    <Stack spacing={24}>
      {enabledOKPOCode && (
        <GridFields>
          <Field.Text
            label={t('client.legal.companyActivities.OKPOCode.label')}
            name="OKPOCode"
            placeholder={t(
              'client.legal.companyActivities.OKPOCode.placeholder'
            )}
          />
        </GridFields>
      )}
      {values.activityTypes.map((_, index) => (
        <Stack key={activityTypesKeys[index]} spacing={12}>
          <Header
            index={index}
            onAddActivity={onAddActivity}
            onRemoveActivity={onRemoveActivity}
          />
          <GridFields>
            <Fields index={index} />
          </GridFields>
        </Stack>
      ))}
    </Stack>
  );
};
